export enum NetworkErrors {
    LOST_CONNECTION = 'lostConnection'
}

export type NetworkEvents = {
    'General.Network.SHOW_ERROR': NetworkErrors;
    'General.Network.CLOSE_ERROR': NetworkErrors;
};
